// extracted by mini-css-extract-plugin
module.exports =  {"description":"_93444fe79c--description--SqTNp"};